import {ReportData} from "../../../reports/report.data";
import {collection, field} from "@fedeltapointofsale/data-client";
import {MemberReportSelectionData} from "../../member/controls/member-report-selection-control.component";

export class MemberDetailsReportData extends ReportData<MemberDetailsReportData> {
    @field reportType: string = "SIMPLE";

    @collection(MemberReportSelectionData) members: MemberReportSelectionData[];
}
